"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Slider_1 = require("@material-ui/core/Slider");
var Typography_1 = require("@material-ui/core/Typography");
var Theme_1 = require("./Theme");
exports.default = (function (props) {
    return (React.createElement(reactstrap_1.FormGroup, { className: props.className, style: props.style },
        React.createElement(Theme_1.default, { color: "primary" },
            React.createElement(Typography_1.default, { id: "label" }, props.label),
            React.createElement(Slider_1.default, { value: props.value, "aria-labelledby": "label", onChange: props.onChange, onDragEnd: props.onDragEnd, min: props.min, max: props.max, step: props.step }))));
});
//# sourceMappingURL=FormControlSlider.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlSlider.js
// module id = 2232
// module chunks = 0